import { chatsHandler } from "./chats";
import { homeHandler } from "./home";
import { mehubHandler } from "./mehub";
import { messagesHandler } from "./messages";
const allowedOrigins = [
  "https://www.xing.com",
  "https://preview.xing.com",
  "http://localhost:8080"
];
const xingboxOrigin = /^http:\/\/.+\b.k?env.xing.com\b$/;
const dockerOrigin = /^https:\/\/.+\b.env.xing.com\b$/;
function handleOrigin(origin) {
  return allowedOrigins.includes(origin) || xingboxOrigin.test(origin) || dockerOrigin.test(origin) ? origin : "https://www.xing.com";
}
function addingParams(param) {
  return param ? `${param}&redirection=false` : "redirection=false";
}
function getRedirectionUrl(path, origin) {
  let redirectUrl = null;
  const chain = [mehubHandler, homeHandler, messagesHandler, chatsHandler];
  if (!/redirection=false/.test(path)) {
    const [url, param = ""] = path.split("?");
    const newParam = addingParams(param);
    chain.some((handlerFn) => {
      const result = handlerFn(url);
      if (result) {
        redirectUrl = `${handleOrigin(origin)}${result}?${newParam}`;
      }
    });
  }
  return redirectUrl;
}
export {
  getRedirectionUrl,
  handleOrigin
};
